export default {
  meta: {
    title: '知识库',
  },
};
